export class TypeEntretien {
    id: number;
    name: string;
}


